class AdventCalendar extends HTMLElement {
  constructor() {
    super()
    this.mode = (window.adventCalendarMode == 'simplified') ? 'simplified' : 'modal'
    this.modal
    this.calendarContainer
    this.slotContainer
    this.slots
    this.simpleMode = false
    this.modalmode = false
  }

  connectedCallback() {

    // determine if in simplified or modal mode
    if(this.mode == 'simplified') {
      this.simpleMode = true
    } else {
      this.modalMode = true
    }

    // activate any previously clicked slots using local storage
    if (this.modalMode && localStorage.getItem('active-advent-slots')) {
      let activeAdventSlots = JSON.parse(localStorage.getItem('active-advent-slots'));
      for (const slotId of activeAdventSlots) {
        document.querySelector(slotId).classList.add("viewed", "active");
      }
    }

    this.modal = this.querySelector('#advent-calendar-modal')
    this.calendarContainer = this.querySelector('.calendar-container')
    this.slotContainer = this.querySelector('.slot-container')
    this.slots = this.querySelectorAll('.slot')

    // Initialize video transition for simplified mode
    if(this.simpleMode) {
      this.initVideoTransition()
    }


    // Add click event to each calendar slot to show dedicated slot view
    this.slots.forEach((slot) => {
      if(this.modalMode) {
        // determine if slot start date is today, or already occurred
        // if slot is future date, it is not clickable
        const dateString = slot.dataset.startDate;
        if(!dateString) return false
        const dateParts = dateString.split('-');
        const dateObject = new Date(dateParts[2], dateParts[0] - 1, dateParts[1]);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        // slot can be clicked so add click event
        if (!(dateObject > today)) {
          slot.addEventListener('click', this.onCalendarSlotClick__ModalMode.bind(this, slot))
        }
      }
    });


    if(this.modalMode) {
      // Add transtion end event to hide modal from DOM after appearing
      this.modal.addEventListener('transitionend', (e) => {
        if(!e.target.classList.contains('modal')) return
        this.modal.classList.remove('active');
      });

      // Add click event to return to calendar view from the dedicated slot view
      const backButton = this.querySelector('[js-return-to-calendar]')
      backButton.addEventListener('click', this.onReturnToCalendarClick.bind(this, backButton))
    }
  }

  onCalendarSlotClick__ModalMode(slot) {
    // save clicked slot in local storage
    if (localStorage.getItem('active-advent-slots')) {
      let activeAdventSlots = JSON.parse(localStorage.getItem('active-advent-slots'));
      activeAdventSlots.push(`#${slot.getAttribute('id')}`);
      localStorage.setItem('active-advent-slots', JSON.stringify(activeAdventSlots));
    } else {
      let newActiveAdventSlots = [`#${slot.getAttribute('id')}`];
      localStorage.setItem('active-advent-slots', JSON.stringify(newActiveAdventSlots));
    }

    // show slot image in modal
    this.querySelectorAll('.slot-image').forEach((div) => {
      div.classList.remove('active')
      div.querySelector('.slot-image__modal')?.classList.remove('active')
    })
    this.querySelectorAll(`.${slot.dataset.modalImage}`).forEach((div) => {
      div.classList.add('active')
      if(div.querySelector('.slot-image__modal')){
        //wait for 500 ms
        setTimeout(() => {
          div.querySelector('.slot-image__modal').classList.add('active')
        }, 500)
      }
    })

    //modify modal background color class
    this.modal.classList.forEach(className => {
      if (className.startsWith('slot-active-')) {
        this.modal.classList.remove(className)
      }
    });
    this.modal.classList.add(slot.dataset.modalClass)

    // declare slot as being viewed
    slot.classList.add('viewed')

    //force static grey background
    document.querySelector('body').classList.add('js-focusable-widget-open','js-modal-open')

    // show modal
    this.modal.classList.remove('fade-out')
    this.modal.classList.add('active')

    // Let modal stay for some time, then fade it out
    setTimeout(() => {

      // Fade modal out
      this.modal.classList.add('fade-out')

      // Fade in-and-out content container
      this.calendarContainer.classList.add('fade-out')
      this.slotContainer.classList.add('fade-in')

      if(this.getAttribute('data-scroll-top')) window.scrollTo(0, 0)

      if(window.innerWidth < 1025) {
        this.style.maxHeight = `${this.slotContainer.offsetHeight + 50}px`
      }

      document.querySelector('body').classList.remove('js-focusable-widget-open','js-modal-open')

    }, 1700);

  }

  onCalendarSlotClick__SimplifiedMode(slot) {
    //query for first <a> tag, gert href, and go to that url in same tab
    const aTag = slot.querySelector('a')
    if(aTag) {
      window.location.href = aTag.href
    }
  }

  /**
   * Show calendar view
   * @param {object} button
   */
  onReturnToCalendarClick(button) {
    if(this.getAttribute('data-scroll-top')) window.scrollTo(0, 0)
    this.revealSlotImages()
    this.calendarContainer.classList.remove('fade-out')
    this.slotContainer.classList.remove('fade-in')
    this.style.maxHeight = 'none'
  }

  /**
   * Get start date from calendar slot data-attribute and determine if active
   */
  revealSlotImages() {
    this.slots.forEach((slot) => {
      if(slot.classList.contains('viewed')) {
        slot.classList.add('active')
      }
    });
  }

  /**
   * Initialize video transition from first video to second video
   */
  initVideoTransition() {
    const isMobile = window.innerWidth < 1025
    const videoPrefix = isMobile ? 'mobile' : 'desktop'
    const firstVideo = this.querySelector(`#advent-video-${videoPrefix}-1`)
    const secondVideo = this.querySelector(`#advent-video-${videoPrefix}-2`)

    if (!firstVideo || !secondVideo) return

    // When first video ends, hide it and play the second video
    firstVideo.addEventListener('ended', () => {
      firstVideo.classList.add('hidden')
      secondVideo.play().catch(err => {
        console.warn('Second video autoplay failed:', err)
      })
    })

    // Ensure first video plays on load
    firstVideo.play().catch(err => {
      console.warn('First video autoplay failed:', err)
    })
  }

}

if (!customElements.get('advent-calendar')) customElements.define('advent-calendar', AdventCalendar)